import { render, staticRenderFns } from "./UiLink.vue?vue&type=template&id=707dbf6e&"
import script from "./UiLink.vue?vue&type=script&lang=js&"
export * from "./UiLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports